const postStatus = {
	draft: 'Rascunho',
	published: 'Publicado',
	archived: 'Arquivado'
};

export { postStatus };
